// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3pGX_","buttons":"RemoveExpirationActionButtons_buttons__3Qij9"};